import { putInvite } from '../api/putInvite';

export const setPutInvite = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await putInvite(params);
            
            alert('Сохранено')
          
            if (callback) {
                callback();
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}